import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { BaseComponent } from '../../../architeture/base/base.component';
import { Aluno } from '../../../core/aluno';
import { FiltroAluno } from '../../../core/filtro/filtro-aluno';
import { PageInfo } from '../../../core/page-info';
import { AlunoService } from '../../../services/aluno/aluno.service';

@Component({
  selector: 'listar-historico-aluno',
  templateUrl: './listar-historico-aluno.component.html',
  styleUrls: ['./listar-historico-aluno.component.css']
})
export class ListarHistoricoAlunoComponent extends BaseComponent implements OnInit, OnChanges {

  @Input() aluno: Aluno;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  mostrarTabela = false;
  msg: string;

  displayedColumns: string[] = ['matricula', 'nome', 'dataEntrada', 'dataSugestaoDesligamento', 'dataDesligamento', 'motivoDesligamento', 'stAtivo'];
  dataSource: MatTableDataSource<Aluno> = new MatTableDataSource();
  
  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  constructor(
    private alunoService: AlunoService,
    private activatedRoute: ActivatedRoute
  ) {
    super();
    this.carregarPerfil = new CarregarPerfil();
  }

  ngOnInit() {     
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);     
    this.dataSource.paginator = this.paginator;   
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.aluno && changes.aluno.currentValue) {
      this.listar();
    }
  }

  limpar() {
    this.mostrarTabela = false;
    this.dataSource.data = [];
  }

  listar() {
    const pageInfo = new PageInfo();
    if(this.paginator) {
      this.paginator.firstPage();
    }
    this.listarHistorico(pageInfo);
  }

  private listarHistorico(pageInfo: PageInfo) {
    const filtro = this.createFiltro();
    this.alunoService.listHistoricoAndPaged(pageInfo, filtro)
      .subscribe((resp: any) => {
        this.numberItens = resp.totalElements;
        this.verificaMostrarTabela(resp.content);
      });
  }

  private createFiltro() {
    const filtro = new FiltroAluno();
    filtro.cpf = this.aluno.pessoaFisica.cpf;
    if(filtro.cpf) {
      filtro.cpf = filtro.cpf.replace(/[^0-9]/g,'');
    }
    return filtro;
  }

  onEventPaginate(event?: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    const pageInfo = new PageInfo();
    pageInfo.pageSize = this.pageSize;
    pageInfo.actualPage = this.pageIndex;
    this.listarHistorico(pageInfo);
  }

  verificaMostrarTabela(alunos: Aluno[]) {
    if (!alunos || alunos.length === 0) {
      this.mostrarTabela = false;
      this.msg = 'Nenhum aluno encontrado.';
    } else {
      this.mostrarTabela = true;
    }
    this.dataSource.data = alunos ? alunos : [];
  }
}
